module.exports = __webpack_public_path__ + "static/The Demex Group-b1f1fed45314bab015ae73dea988fadd.jpg";